import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import '@fontsource-variable/fraunces/opsz.css';
import '@fontsource-variable/fraunces/opsz-italic.css';
import './styles/base.css';
import './styles/type.css';
import './styles/header.css';
import './styles/stage.css';
import './styles/rails.css';
import './styles/footer.css';
import './styles/sheet.css';
import './styles/overlays.css';
import './styles/features.css';
import './styles/responsive.css';
import './styles/look.css';
import './styles/layouts.css';
import './styles/a11y.css';

import { setAmbientVolume } from './audio/ambient';
import { setVolume } from './audio/fx';
import * as engine from './app/engine';
import { app, emit, loadState, on, syncFromStorage } from './app/state';
import { STORAGE_KEY } from './core/constants';
import { initAnalytics } from './platform/analytics';
import { registerPWA } from './platform/pwa';
import { startHeartbeat } from './platform/ticker';
import { initChrome } from './ui/chrome';
import { initPresets } from './ui/presets';
import { initPrivacy } from './ui/privacy-view';
import { initSettings } from './ui/settings-view';
import { closeSheet, initSheet, openSheet } from './ui/sheet';
import { initSideTimers, tickSide } from './ui/side-timers';
import { initStats } from './ui/stats-view';
import { initTasks } from './ui/tasks-view';
import { initTimerView, renderTitle } from './ui/timer-view';
import { initAppearance } from './ui/appearance';
import { initFlip } from './ui/flip';
import { initPip } from './ui/pip';
import { toast } from './ui/toast';

function boot() {
  const source = loadState();
  initAnalytics(); // first, so the counters see everything below
  setVolume(app.data.settings.volume);
  setAmbientVolume(app.data.settings.ambientVolume);

  initSheet();
  initChrome();
  initPresets(() => openSheet('settings'));
  initTasks(closeSheet);
  initStats();
  initSettings();
  initPrivacy();
  initSideTimers();
  initTimerView({ sideFrame: tickSide });
  initFlip();
  initPip();
  initAppearance(); // last: applying the layout docks panes the views above already render

  // Process anything that finished while the app was closed (multi-phase catch-up).
  engine.tick();
  if (app.data.run.running) {
    toast('Timer resumed');
    engine.syncRunEffects();
  }
  if (source === 'legacy') toast('Your data was upgraded to the new format', 'var(--sage)');

  // Background heartbeat: keeps completion on time in throttled/hidden tabs (B9).
  startHeartbeat(() => {
    engine.tick();
    tickSide();
    renderTitle();
  });

  // Another tab changed the data: adopt it (B12).
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY && syncFromStorage(e.newValue)) {
      emit('run', 'settings', 'tasks', 'stats', 'side');
      engine.syncRunEffects();
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) engine.tick();
  });

  if (!app.storageOk) warnStorage();
  on('storage', warnStorage);

  void registerPWA();
}

let warned = false;
function warnStorage() {
  if (warned) return;
  warned = true;
  toast("This browser isn't saving data (private mode or storage full). Progress will be lost on close.", {
    color: 'var(--tomato)',
    sticky: true,
  });
}

boot();
